import React from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "antd";

import UserHeaderActions from "./user-header-actions";
import UserHeaderActionsSelf from "./user-header-actions-self";
import AvatarPhoto from "../../avatar/avatar-photo";
import { LinkedMention, Localize } from "../../service";
import { Loader } from "../../result";

import './user-header.css';


const HeaderActions = ({ itsMe, user }) => {

    if(itsMe){
        return <UserHeaderActionsSelf />;
    }

    return (
        <UserHeaderActions
            follow={ user.me_following }
            userId={ user.id }
            userNickname={ user.nickname }
        />
    );
};

const UserHeader = (props) => {

    const {
        loading,
        userLogin,
        itsMe,
        user,
    } = props;


    return (
        <div className="user-header">
            { loading ?
                <Loader /> :
                <Row className={ user.status === "block" ? "blocked" : "" }>
                    <Col xs={24} sm={24}  md={8} span={8} className="user-header-photo">
                        <AvatarPhoto
                            photoUrl={ user.avatar }
                            size={150}
                            initials={ user.initials }
                            blocked={ user.status === "block" ? "big" : null }
                        />
                    </Col>
                    { user.status === "block" ?
                        <Col xs={24} sm={24} md={16} span={16} className="user-header-info">
                            <h1>{userLogin}</h1>
                            <h4 className="site-sub-text-color">
                                <Localize>GLOBAL.Text_InactiveUser</Localize>
                            </h4>
                        </Col>:
                        <Col xs={24} sm={24} md={16} span={16} className="user-header-info">
                            <div className="user-header-data">
                                <h1>{userLogin}</h1>
                                <HeaderActions
                                    itsMe={itsMe}
                                    user={user}
                                />
                            </div>
                            <ul className="user-header-statistics company-link-hover">
                                <li className="post-amount-holder site-sub-text-color">
                                    <Link to={`/${userLogin}`}>
                                        <b className="site-bold-color">{ user.counters.published }</b>
                                        <Localize wrap>MENUS.Label_Posts</Localize>
                                    </Link>
                                </li>
                                <li className="followers-holder site-sub-text-color">
                                    <Link to={`/${user.nickname}/followers`}>
                                        <b className="site-bold-color">{user.counters.followers}</b>
                                        <Localize wrap>MENUS.Label_Followers</Localize>
                                    </Link>
                                </li>
                                <li className="following-holder site-sub-text-color">
                                    <Link to={`/${user.nickname}/following/users`}>
                                        <b className="site-bold-color">{user.counters.following}</b>
                                        <Localize wrap>MENUS.Label_Following</Localize>
                                    </Link>
                                </li>
                            </ul>
                            <div className="user-header-about">
                                {user.name &&
                                    <h2 className="user-header-name">
                                        {user.name}
                                    </h2>
                                }
                                <div className="user-header-contact">
                                    { user.dealer && user.dealer.company_name &&
                                        <p className="dealer-name site-title-color">
                                            { user.dealer.company_name }
                                        </p>
                                    }
                                    { !!user.job_type &&
                                    <p className="job-description site-sub-text-color">
                                        <Localize>{ `FORMS.Select_OptionLabel_${ user.job_type }` }</Localize>
                                    </p>
                                    }
                                    { !!user.email &&
                                    <p>
                                        <a href={`mailto:${ user.email }`}
                                           target="_blank"
                                           rel="noopener noreferrer"
                                           className="outer-link"
                                        >
                                            { user.email }
                                        </a>
                                    </p>
                                    }
                                    { !!user.phone &&
                                    <p>
                                        <a href={`tel:${ user.phone }`}
                                           target="_blank"
                                           rel="noopener noreferrer"
                                           className="outer-link"
                                        >
                                            { user.phone }
                                        </a>
                                    </p>
                                    }
                                </div>
                                { user.about ?
                                    <div className="user-header-description">
                                        <LinkedMention searchSigns={['@', '^', '#']}>
                                            { user.about }
                                        </LinkedMention>
                                    </div> : null
                                }
                            </div>
                        </Col>
                    }
                </Row>
            }
        </div>
    );
};

export default UserHeader;